import { render } from "./ReCaptcha.vue?vue&type=template&id=4b82e9ea&ts=true"
import script from "./ReCaptcha.vue?vue&type=script&lang=ts"
export * from "./ReCaptcha.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__